import { ref } from 'vue'
import uniqueId from 'lodash.uniqueid'

export const NOTIFICATION_TYPE_SUCCESS = 'success'
export const NOTIFICATION_TYPE_ERROR = 'error'
export const NOTIFICATION_TYPE_WARNING = 'warning'
export const NOTIFICATION_TYPE_INFO = 'info'

export const NOTIFICATION_TYPES = [
  NOTIFICATION_TYPE_SUCCESS,
  NOTIFICATION_TYPE_ERROR,
  NOTIFICATION_TYPE_WARNING,
  NOTIFICATION_TYPE_INFO,
]

/**
 * List of notifications
 */
export const items = ref([])

/**
 * Create notification
 *
 * @param {string} text   - Notification content
 * @param {object} config - Configuration object
 * @param {string}  [config.type]      - Type (Color of notification)
 * @param {number}  [config.timeout]   - Timeout of closing
 * @param {boolean} [config.closable] - Is notification can be closed

 * @return {string} - Index of item that can be closed
 */
export const createNoty = async (text, config = {}) => {
  let item = {
    text: text,
    key: uniqueId('noty_'),
    type: NOTIFICATION_TYPES.includes(config.type)
      ? config.type
      : NOTIFICATION_TYPE_SUCCESS,
    timeout: Object.prototype.hasOwnProperty.call(config, 'timeout')
      ? Number(config.timeout)
      : 6000,
    closable: Object.prototype.hasOwnProperty.call(config, 'closable')
      ? Boolean(config.closable)
      : false,
  }

  items.value.push(item)

  if (item.timeout > 0) {
    setTimeout(() => {
      let index = items.value.indexOf(item)
      if (index !== -1) {
        items.value.splice(index, 1)
      }
    }, item.timeout)
  }

  return item.key
}

/**
 * Remove notification from list
 *
 * @param key
 * @return {Promise<void>}
 */
export const removeNoty = async (key) => {
  let index = items.value.findIndex((i) => i.key === key)
  if (index !== -1) {
    items.value.splice(index, 1)
  }
}
